import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { BaseResponse } from '../models'

const _BASE_URL = import.meta.env.REACT_APP_AUTH_API_BASE_URL!

export interface IdP {
  identityProvider: string
  displayName: string
  redirectUri: string
  responseType: string
  clientId: string
  scope: string
}

export interface GetSubdomainIdPsRequest {
  subdomain: string
}
export const idpApi = createApi({
  reducerPath: 'idpApi',
  baseQuery: fetchBaseQuery({ baseUrl: _BASE_URL }),
  tagTypes: ['IdP'],
  endpoints: (builder) => ({
    getSubdomainIdPs: builder.query<BaseResponse<IdP[]>, GetSubdomainIdPsRequest>({
      query: (request) => {
        return {
          url: '/v2/console/oauth2/idps',
          params: {
            subdomain: request.subdomain,
          },
        }
      },
      providesTags: ['IdP'],
    }),
  }),
})

export const { useGetSubdomainIdPsQuery } = idpApi
